import { c as _c } from "react/compiler-runtime";
import { SortSelector } from "@components/common/sort-selector";
import { DEFAULT_TEAMS_SORT_BY, TEAMS_SORT_BY_MAP, TEAMS_SORT_OPTIONS } from "@components/teams/teams-constants";
import { getTeamsSortBy } from "@utils/team-utils";
/** Component to change the teams sort criteria */
export function TeamsSort(t0) {
  const $ = _c(5);
  const {
    sortBy,
    setSortBy
  } = t0;
  const validSortBy = sortBy && TEAMS_SORT_BY_MAP[sortBy] ? sortBy : DEFAULT_TEAMS_SORT_BY;
  let t1;
  if ($[0] !== setSortBy) {
    t1 = function handleSortChange(newSortItem) {
      const newSortBy = getTeamsSortBy(newSortItem);
      setSortBy(newSortBy);
    };
    $[0] = setSortBy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSortChange = t1;
  const t2 = TEAMS_SORT_BY_MAP[validSortBy];
  let t3;
  if ($[2] !== handleSortChange || $[3] !== t2) {
    t3 = <SortSelector sortOptions={TEAMS_SORT_OPTIONS} sortItem={t2} setSortItem={handleSortChange} subjectType="Team" />;
    $[2] = handleSortChange;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}